import { useTranslation } from "react-i18next";

import { Control } from "components/ui-kit/control";

import { ESteps } from "types/enums";

const RulesPage = () => {
    const { t } = useTranslation();

    return (
        <>
            <h3>{t("yjlnsr0kcam")}</h3>
            <Control.Textarea name={`${ESteps.Rules}.requiredUniDocuments`} placeholder={t("8zmaby26o4x")} label={t("ycqzfurg44")} isRequired />
            <h3>{t("bmwtus5rqhg")}</h3>
            <Control.Textarea name={`${ESteps.Rules}.requiredStudentsDocuments`} placeholder={t("c605fiky0mv")} label={t("r3298amhsc")} isRequired />
            <h3>{t("cs0v6ui1omf")}</h3>
            <Control.Input name={`${ESteps.Rules}.committee.name`} placeholder={t("hv8pf9i2h6e")} label={t("tf3upuq6i6")} isRequired />
            <Control.Row>
                <Control.Input name={`${ESteps.Rules}.committee.phone`} placeholder="+7" label={t("pwi937lhaa8")} isRequired />
                <Control.Input name={`${ESteps.Rules}.committee.email`} placeholder="@mail.ru" label={t("6rximp8oqma")} isRequired />
            </Control.Row>
        </>
    );
};

export default RulesPage;
